import request from '@/utils/request'
import { http } from '@/utils/http'

/**
 * 用户登录
 * @param {Object} params - 登录参数
 * @param {string} params.username - 用户名
 * @param {string} params.password - 密码
 * @returns {Promise} 登录结果
 */
export const login = (params) => {
  return http.post('/sys/mLogin', { ...params })
  // return request({
  //   url: '/sys/mLogin',
  //   method: 'POST',
  //   data: params,
  // })
}

/**
 * 获取用户信息
 * @returns {Promise} 用户信息
 */
export const getUserInfo = () => {
  return http.get('/sys/getUserInfo', {})
  // return request({
  //   url: '/sys/getUserInfo',
  //   method: 'GET',
  // })
}

/**
 * 用户登出
 * @returns {Promise} 登出结果
 */
export const logout = () => {
  return http.post('/sys/logout', {})
  // return request({
  //   url: '/sys/logout',
  //   method: 'POST',
  // })
}

/**
 * 获取管理看板数据
 * @returns {Promise} 管理看板数据
 */
export const getMgmtDash = () => {
  return http.get('/iac/schd/app/mgmtDash', {})
}
/**
 * 获取我的权限
 * @returns {Promise} 权限信息
 */
export const getMyAppAuth = () => {
  return http.get('/iac/role/appAuth/myAppAuth')
}

// /iac/schd/app/employeeinfo/my 获取我的员工信息
export const getMyStaffInfo = () => {
  return http.get('/iac/schd/app/employeeinfo/my', {})
}
